import { LitElement } from 'lit';

export class ScrollFade extends LitElement {
  static get properties() {
    return {
      colour: { type: String },
    };
  }
  createRenderRoot() {
    return this;
  }

  constructor() {
    super();

    if (!this.colour) {
      this.colour = '#FFFFFF';
    }

    this.showStart = false;
    this.showEnd = false;
    this.scrollContainer = this.querySelector('[scroll-container]');
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.scrollContainer) {
      throw new Error('scroll-container on a child element is required');
    };

    this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true });
    this.scrollContainer.addEventListener('touchmove', this.handleScroll, { passive: true });

    this.appendFade();
    this.showFade();
    window.addEventListener('resize', () => this.showFade());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.scrollContainer.removeEventListener('scroll', this.handleScroll, { passive: true });
    this.scrollContainer.removeEventListener('touchmove', this.handleScroll, { passive: true });
    window.removeEventListener('resize', this.showFade);
  }

  appendFade() {
    const fadeContainer = document.createElement('div');
    fadeContainer.className = 'scroll_fade_container';
    fadeContainer.innerHTML = `
      <div class="scroll_fade_start"
      style="
        left: -1px;
        background: linear-gradient(
          to right,
          ${this.colour} 0%,
          ${this.colour}CC 40%,
          ${this.colour}80 70%,
          transparent 100%
        );
      "></div>
      <div class="scroll_fade_end"
      style="
        right: -1px;
        background: linear-gradient(
          to left,
          ${this.colour} 0%,
          ${this.colour}CC 40%,
          ${this.colour}80 70%,
          transparent 100%
        );
      "></div>
    `;
    this.scrollContainer.insertAdjacentElement('afterend', fadeContainer);
  }

  showFade() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
    
    this.showEnd = Math.ceil(scrollLeft + clientWidth) < scrollWidth;
    
    if (scrollWidth <= clientWidth) {
      this.showEnd = false;
    }

    this.scrollContainer.toggleAttribute('show-end', this.showEnd);
  }

  handleScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
    
    this.showStart = scrollLeft > 0;
    
    this.showEnd = Math.ceil(scrollLeft + clientWidth) < scrollWidth;

    this.scrollContainer.toggleAttribute('show-start', this.showStart);
    this.scrollContainer.toggleAttribute('show-end', this.showEnd);
  }
}

window.customElements.get('scroll-fade') ||
  window.customElements.define('scroll-fade', ScrollFade);
